/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useAssignedProductsRepair } from 'app/core/api/product-assignment/api-product-assignment';
import { RepairAssignedProduct } from 'app/core/api/product-assignment/api-product-assignment.types';
import LoadingOverlay from 'app/shared/page-parts/LoadingOverlay';
import SharedRoutePath from 'app/shared/SharedRoutePath';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { TileContainer } from '../../../shared/frames/Tile';
import ProductSliderContainer from './ProductSliderContainer';

export default function Products(): JSX.Element {
  const { resource: assignedProducts, loadingMissing } =
    useAssignedProductsRepair();
  const [newProducts, setNewProducts] =
    useState<RepairAssignedProduct[]>();
  const [inProgressProducts, setInProgressProducts] =
    useState<RepairAssignedProduct[]>();
  useEffect(() => {
    const np = assignedProducts?.filter(
      m =>
        m.currentStatus &&
        (m.currentStatus === 'new' ||
          m.currentStatus === 'repair_quote_issued' ||
          m.currentStatus === 'repair_quote_decline' ||
          m.currentStatus === 'diagnosis_quote_decline' ||
          m.currentStatus === 'diagnosis_quote_issued')
    );
    setNewProducts(np);
    const ip = assignedProducts?.filter(
      m =>
        m.currentStatus &&
        // m.currentStatus !== 'new' &&
        // m.currentStatus !== 'repair_quote_issued' &&
        // m.currentStatus !== 'diagnosis_quote_issued' &&
        // m.currentStatus !== 'item_collected' &&
        // m.currentStatus !== 'diagnosis_completed' &&
        // m.currentStatus !== 'repair_completed' &&
        // m.currentStatus !== 'ready_for_collection'
        (m.currentStatus === 'diagnosis_quote_accepted' ||
          m.currentStatus === 'repair_quote_accepted' ||
          m.currentStatus === 'item_received' ||
          m.currentStatus === 'under_diagnosis' ||
          m.currentStatus === 'under_repair')
    );
    setInProgressProducts(ip);
  }, [assignedProducts]);
  const history = useHistory();

  return (
    <div
      style={{
        width: '100%',
        display:
          (newProducts && newProducts.length > 0) ||
          (inProgressProducts && inProgressProducts.length > 0)
            ? 'block'
            : 'none',
      }}
    >
      <LoadingOverlay loadingComplete={!loadingMissing} />
      <div style={{ display: 'flex' }}>
        {newProducts && newProducts.length > 0 && (
          <h3
            style={{
              color: '#31AD31',
              flexGrow: 1,
              fontWeight: 'normal',
            }}
          >
            New
          </h3>
        )}
        <h3
          style={{
            color: '#31AD31',
            flexGrow: 1,
            fontWeight: 'normal',
            textAlign: 'right',
          }}
          onClick={() =>
            history.push(`${SharedRoutePath.CHAT_LIST}/new`)
          }
        >
          {newProducts && newProducts.length > 0 && (
            <>See All ({newProducts?.length})</>
          )}
        </h3>
      </div>

      <div>
        <TileContainer>
          {newProducts && (
            <ProductSliderContainer
              products={newProducts}
              variantType="wide"
              displayType="withoutTracking"
            />
          )}
        </TileContainer>
      </div>
      <div style={{ display: 'flex' }}>
        {inProgressProducts && inProgressProducts.length > 0 && (
          <h3
            style={{
              color: '#31AD31',
              flexGrow: 1,
              fontWeight: 'normal',
            }}
          >
            In progress
          </h3>
        )}
        <h3
          style={{
            color: '#31AD31',
            flexGrow: 1,
            fontWeight: 'normal',
            textAlign: 'right',
          }}
          onClick={() =>
            history.push(`${SharedRoutePath.CHAT_LIST}/inProgress`)
          }
        >
          {inProgressProducts && inProgressProducts.length > 0 && (
            <>See All ({inProgressProducts?.length})</>
          )}
        </h3>
      </div>
      <div>
        <TileContainer>
          {inProgressProducts && (
            <ProductSliderContainer
              products={inProgressProducts}
              variantType="wide"
              displayType="withTracking"
              sliderName="inprogress"
            />
          )}
        </TileContainer>
      </div>
    </div>
  );
}
